import React from 'react';

const LoadingImage = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130 130">
    <path d="M61,114a7,7,0,1,1-7,7A7,7,0,0,1,61,114Z" />
    <path d="M79.5,110a8.5,8.5,0,1,1-8.5,8.5A8.54,8.54,0,0,1,79.5,110Z" />
    <path d="M99,98a10,10,0,1,1-10,10A10,10,0,0,1,99,98Z" />
    <path d="M114,75a12,12,0,1,1-12,12,12,12,0,0,1,12-12Z" />
    <path d="M116.5,43A13.5,13.5,0,1,1,103,56.5,13.55,13.55,0,0,1,116.5,43Z" />
    <path d="M95.5,13A14.5,14.5,0,1,1,81,27.5,14.54,14.54,0,0,1,95.5,13Z" />
    <path d="M56.51,2A16.5,16.5,0,1,1,40,18.49,16.54,16.54,0,0,1,56.51,2Z" />
    <path d="M18,25A18,18,0,1,1,0,43,18,18,0,0,1,18,25Z" />
  </svg>
);

export default LoadingImage;
